import { useState } from "react";
import {
    Button,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";

interface Props {

    isOpen: boolean;

    toggle: () => void;

    onSubmit: (remarks: string) => Promise<void>;

}

const RejectRequestModal = ({
    isOpen,
    toggle,
    onSubmit
}: Props) => {

    const [remarks, setRemarks] =
        useState("");

    const [loading, setLoading] =
        useState(false);

    const submit = async () => {

        if (!remarks.trim()) {

            alert("Remarks are required.");

            return;

        }

        setLoading(true);

        try {

            await onSubmit(remarks);

            setRemarks("");

            toggle();

        }
        finally {

            setLoading(false);

        }

    };

    return (

        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
        >

            <ModalHeader toggle={toggle}>

                Reject Request

            </ModalHeader>

            <ModalBody>

                <FormGroup>

                    <Label>

                        Remarks

                    </Label>

                    <Input
                        type="textarea"
                        rows={4}
                        value={remarks}
                        onChange={(e) =>
                            setRemarks(
                                e.target.value
                            )
                        }
                    />

                </FormGroup>

            </ModalBody>

            <ModalFooter>

                <Button
                    color="secondary"
                    onClick={toggle}
                >
                    Cancel
                </Button>

                <Button
                    color="danger"
                    disabled={loading}
                    onClick={submit}
                >

                    {

                        loading

                            ?

                            "Rejecting..."

                            :

                            "Reject"

                    }

                </Button>

            </ModalFooter>

        </Modal>

    );

};

export default RejectRequestModal;